import { useEffect, useMemo, useState } from "react";

export const useDeviceTheme = (): {
  theme: "dark" | "light";
} => {
  const mediaQuery = useMemo(() => {
    return window.matchMedia("(prefers-color-scheme: dark)");
  }, []);

  const [theme, setTheme] = useState<"dark" | "light">(
    mediaQuery.matches ? "dark" : "light"
  );

  useEffect(() => {
    const onChange = (event: MediaQueryListEvent) => {
      setTheme(event.matches ? "dark" : "light");
    };

    mediaQuery.addEventListener("change", onChange);

    return () => {
      mediaQuery.removeEventListener("change", onChange);
    };
  }, [mediaQuery]);

  return { theme };
};
